import { Route, Routes } from 'react-router-dom'

import RoleMiddleware from '@/components/RoleMiddleware.jsx'
import { EARLY_ACCESS } from '@/enums/userRoles'
import Showcase from '@/deprecated/Showcase'

const ShowcaseRouter = (
    <Routes>
        <Route
            index
            element={
                <RoleMiddleware roles={[EARLY_ACCESS]}>
                    <Showcase />
                </RoleMiddleware>
            }
        />
    </Routes>
)

export default ShowcaseRouter
